module.exports = __webpack_public_path__ + "static/media/ICBT 2c.d220b9cc.jpg";